export const MediosActionTypes = {
  API_RESPONSE_SUCCESS: '@@medios/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@medios/API_RESPONSE_ERROR',

  GET_MEDIO: '@@medios/GET_MEDIO',
  LIST_MEDIOS: '@@medios/LIST_MEDIOS',
  ADD_MEDIO: '@@medios/ADD_MEDIO',
  UPDATE_MEDIO: '@@medios/UPDATE_MEDIO',
  DELETE_MEDIO: '@@medios/DELETE_MEDIO',
  SET_FILTER: '@@medios/SET_FILTER',

  RESET: '@@medios/RESET'
}
